module.exports = __webpack_public_path__ + "static/casava-c5bb99697c4a8c37f6a6eb871f9490f3.jpg";